import { useState } from "react";
import { Loader2 } from "lucide-react";
import { ModelForm } from "@/components/create/ModelForm";
import { DocLink, ModelPicker } from "@/components/create/ModelPicker";
import { useHfCatalog } from "@/lib/studio";

// Model picker + schema-driven form. Unverified and price-pending models stay visible but can't be selected.
export function ProStudio({ filter, initialModelId, testId = "pro-studio" }) {
  const cat = useHfCatalog();
  const models = (cat.data?.models || []).filter(filter);
  const [selected, setSelected] = useState(null);
  const model = selected || models.find((m) => m.id === initialModelId && m.status === "available") || models.find((m) => m.status === "available");
  if (cat.isLoading) return <div className="flex h-32 items-center justify-center text-zinc-500"><Loader2 className="h-5 w-5 animate-spin" /></div>;
  return (
    <div className="space-y-5 rounded-[22px] border border-white/[0.08] bg-ink-850 p-4 sm:p-5" data-testid={testId}>
      <div>
        <p className="mb-2 text-[11px] font-medium uppercase tracking-[0.16em] text-zinc-500">Model · {models.filter((m) => m.status === "available").length} ready of {models.length}</p>
        <ModelPicker models={models} selected={model} onSelect={setSelected} />
      </div>
      {model && (
        <div className="space-y-4 border-t border-white/[0.06] pt-4">
          <div className="flex items-center justify-between gap-3">
            <h3 className="text-sm font-semibold text-white" data-testid="pro-studio-model-title">{model.family} · {model.workflow}</h3>
            <DocLink m={model} />
          </div>
          <ModelForm key={model.id} model={model} />
        </div>
      )}
    </div>
  );
}
